import React, { Component } from "react";
import Modal from "react-modal";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCopy, faEnvelope, faPhone } from "@fortawesome/free-solid-svg-icons";
import {
  faFacebookF,
  faTwitter,
  faLinkedin,
  faWhatsapp
} from "@fortawesome/free-brands-svg-icons";
import {
  FacebookShareButton,
  TwitterShareButton,
  LinkedinShareButton,
  WhatsappShareButton
} from "react-share";
import CopyToClipboard from "react-copy-to-clipboard";
import { isMobile } from "react-device-detect";

import globals from "../../globals";

import LocalizedStrings from "react-localization";
import en from "../../localization/localization-en.json";

let strings = new LocalizedStrings({ en });

class SharingInviteView extends Component {
  state = { show: false, show_view: false };

  componentDidMount() {
    const self = this;
    setTimeout(function() {
      self.setState({ show: true });
    }, 100);
  }

  componentWillMount() {
    Modal.setAppElement("body");
  }

  render() {
    var style = { top: "-250px" };
    if (this.state.show === true) {
      style = { top: "0px" };
    }
    if (this.state.show_view === true) {
      return <div />;
    }
    return (
      <Modal className="follow-views" isOpen={true}>
        <div className="follow-return" onClick={this.handleCloseViewEvent} />
        <div style={style} className="follow-view center">
          <div className="max_width_500 pb-2 pt-2">
            <label className="name pb-2">
              Each new friend =<br />1 additional entry
            </label>
            <input
              type="text"
              readOnly={true}
              className="yaystack_input_text mb-3"
              value={globals.websiteURL + "invite/" + this.props.username}
            />
          </div>

          <CopyToClipboard
            text={globals.websiteURL + "invite/" + this.props.username}
            onCopy={this.handleCloseView}
          >
            <button className="btn btn_primary btn_yaystack btn_invite">
              <FontAwesomeIcon icon={faCopy} />
            </button>
          </CopyToClipboard>
          {this.renderMobileShare()}
          <button
            className="btn btn_primary btn_yaystack btn_invite"
            onClick={this.openMailer}
          >
            {/* <ion-icon class="ion-icon" name="text" /> */}
            <FontAwesomeIcon icon={faEnvelope} />
          </button>

          <br />
          <FacebookShareButton
            className="btn btn_primary btn_yaystack btn_invite"
            url={globals.websiteURL + "invite/" + this.props.username}
            beforeOnClick={this.handleCloseView}
            quote={strings.join_me_on_yaystack}
          >
            <FontAwesomeIcon icon={faFacebookF} />
          </FacebookShareButton>
          <TwitterShareButton
            className="btn btn_primary btn_yaystack btn_invite"
            url={globals.websiteURL + "invite/" + this.props.username}
            beforeOnClick={this.handleCloseView}
            title={strings.join_me_on_yaystack}
          >
            <FontAwesomeIcon icon={faTwitter} />
          </TwitterShareButton>
          <LinkedinShareButton
            className="btn btn_primary btn_yaystack btn_invite"
            url={globals.websiteURL + "invite/" + this.props.username}
            beforeOnClick={this.handleCloseView}
            title={strings.join_me_on_yaystack}
          >
            <FontAwesomeIcon icon={faLinkedin} />
          </LinkedinShareButton>
          <WhatsappShareButton
            className="btn btn_primary btn_yaystack btn_invite"
            url={globals.websiteURL + "invite/" + this.props.username}
            beforeOnClick={this.handleCloseView}
            title={strings.join_me_on_yaystack}
          >
            <FontAwesomeIcon icon={faWhatsapp} />
          </WhatsappShareButton>
          <br />
          <br />
        </div>
      </Modal>
    );
  }

  renderMobileShare() {
    if (isMobile) {
      return (
        <button
          className="btn btn_primary btn_yaystack btn_invite"
          onClick={this.openMessage}
        >
          <ion-icon class="ion-icon" name="text" style={{ fontSize: "28px" }} />
          {/* <FontAwesomeIcon icon={faPhone} /> */}
        </button>
      );
    }
    return <React.Fragment />;
  }

  handleCloseView = event => {
    this.setState({ show: false });
    const self = this;
    setTimeout(function() {
      self.props.handlerInviteFriend();
    }, 600);
  };

  handleCloseViewEvent = event => {
    event.preventDefault();
    this.setState({ show: false });
    const self = this;
    setTimeout(function() {
      self.props.handlerInviteFriend();
    }, 600);
  };

  openMailer = event => {
    event.preventDefault();
    this.handleCloseView();
    const subject = strings.join_me_on_yaystack;

    const body = strings.you_can_join_me_at + this.props.username;
    window.location.href = `mailto:?subject=${subject}&body=${body}`;
  };
  openMessage = event => {
    event.preventDefault();
    this.handleCloseView();
    const body = strings.you_can_join_me_at + this.props.username;

    window.location.href = `sms:?&body=${body}`;
  };
}

export default SharingInviteView;



// WEBPACK FOOTER //
// ./src/components/share/sharing_invite_view.jsx